const onKeyClick = (e, keyCode, func) => {
  if (e.keyCode === keyCode) {
    func();
  }
};

export default onKeyClick;
